import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';

function BulletList({
  items,
  wrap = false,
  size = 'default'
}) {
  if (!items.length) {
    return jsx(Fragment, {});
  }
  if (size === 'large') {
    return jsx("ul", {
      className: "flex list-none flex-wrap",
      children: items.map((item, idx, arr) => jsxs("li", {
        className: "mr-xs inline last:mr-0",
        children: [item, jsx("span", {
          className: clsx('ml-xs', {
            hidden: idx + 1 === arr.length
          }),
          children: "\u2022"
        })]
      }, `bullet-list-${idx}`))
    });
  }
  const [firstItem, ...restItems] = items;
  const containerClassName = wrap ? 'break-words' : 'truncate';
  return jsxs("div", {
    className: containerClassName,
    children: [jsx("span", {
      children: firstItem
    }), restItems.map((listItem, index) => jsxs("span", {
      children: [jsx("span", {
        className: clsx('mx-2xs', {
          'sm:mx-xs': size === 'small'
        }),
        children: "\u2022"
      }), listItem]
    }, index))]
  });
}

export { BulletList };
